import React, { useContext, useEffect } from 'react'
import {HeadTableLeads, RowLeadsforAssign } from "../../ui-components";
import LeadsContext from '../../context/leads';

function ForAssignManager({onToggleTab,setAssignLead, order, idBranch}) {
  const {LeadsManagers,models, Subs, toggle} = useContext(LeadsContext)
  
  useEffect(()=>{
    LeadsManagers(1, order, idBranch);
    Subs();
  },[order, idBranch])

  const overridesHeadTables = {
    Registro: {
      children: "Asignación"
    },
    "Asesor Conekta":{
      children: "Gerencia"
    }
  }
  return (
    <div className="overflow-x-scroll py-2">
   <HeadTableLeads type="forAssign" overrides={overridesHeadTables}/>
   {models?.map((lead, index) => (
    index % 2 == 0 ?
    <RowLeadsforAssign key={lead.id} Lead={lead} overrides={{ 
      Registro: {
        children: `${lead?.dateAsignation}`
      },
      AsesorConekta: {
        children: `${lead?.branch}`
      },
      Button:{
      onClick: () =>{
        onToggleTab(5)
        setAssignLead(lead)
      },
      children:"Asignar Asesor"
    }}}/> :
    <RowLeadsforAssign key={lead.id} Lead={lead} overrides={{ 
      Registro: {
        children: `${lead?.dateAsignation}`
      },
      AsesorConekta: {
        children: `${lead?.branch}`
      },
      Button:{
      onClick: () =>{
        onToggleTab(5)
        setAssignLead(lead)
      },
      children:"Asignar Asesor"
    },
    "Frame 20797":{backgroundColor: "#ffffff"}}}/>
   ))}
  </div>

  )
}

export default ForAssignManager